// extracted by mini-css-extract-plugin
export default {"wrap":"accept-settings_wrap__eyMsM","search-input":"accept-settings_search-input__-Elco"};